/**
 * Use as placeholder for CM Conclusion page
 */

import React from 'react';
import PropTypes from 'prop-types';

import { DateTime } from 'luxon';

const EmptyModuleCertificate = ({
  sponsor
  , contentModule
}) => {
  return (
    <div className="certificate">
      <div className="-cert-content">
        <div className="-cert-header">
          { sponsor ?
            <div className="-sponsor-info">
              <div className="-sponsor-logo">
                { sponsor.logo ?
                  <img alt="sponsor-logo" src={sponsor.logo}/>
                  :
                  null
                }
              </div>
              { sponsor.name ? 
                <div className="-sponsor-name">{sponsor.name}</div>
                :
                null 
              }
              <hr/>
            </div>
            :
            null 
          }
        </div>
        <div className="-cert-body">
          <h2 className="u-centerText">Certificate of Completion</h2>
          <div className="-certifies-that">This is to certify that</div>
          <div className="-completor"></div>
          <div className="-has-successfully">has successfully completed</div>
          <div className="-tm-title">{contentModule.title}</div>
        </div>
        <div className="-cert-sig">
          <div className="-signer-info">
            <div className="-signature">
              {/* <img src="/img/jenna-signature.png"/> */}
            </div>
            <div className="-signer-name">
              Jenna Rouse
            </div>
            <div className="-signer-position">
              President - Pro-ficiency
            </div>
          </div>
        </div>
        <div className="-cert-footer">
          <div className="yt-row with-gutters space-between">
            <div className="yt-col _60">
              <div className="-accreditor-info">
                <div className="-accreditor-logo">
                  <img alt="certificate achieved" src="/img/cert-icons/cert-icon-dark@4x.png"/>
                </div>
                <div className="-accreditor-description">
                  <span>
                    Pro-ficiency provides a comprehensive human performance improvement system for clinical trials. We leverage simulation to provide real-world training for sites and subjects. Sponsors use Pro-ficiency to initiate trial sites faster and more efficiently, and to reduce protocol violations. With the help of Pro-ficiency, Sponsors decrease study time, lower costs, reduce meetings, conduct site feasibility, and predict and avoid study errors.
                  </span>
                </div>
              </div>
            </div>
            <div className="yt-col _25">
              <div className="-partner-logo">

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

EmptyModuleCertificate.propTypes = {
  sponsor: PropTypes.object
  , contentModule: PropTypes.object.isRequired
}

EmptyModuleCertificate.defaultProps = {
  sponsor: null 
}

export default EmptyModuleCertificate;



// WEBPACK FOOTER //
// modules/moduleCertificate/components/EmptyModuleCertificate.js.jsx